import { StaticPageConfig } from "@7egend/dxp-web-core/lib/modules/cms/StaticPages/types"
import { CUSTOM_BLOCKS } from "../blocks"

const { image, text, title } = CUSTOM_BLOCKS.types

export default {
	sections: {
		"11": {
			containers: {
				"birthday-prices/header": {
					blocks: [
						{
							types: [`${image.type}_${image.style}`],
						},
						{
							types: [`${title.type}_${title.style}`],
						},
					],
				},
				"birthday-prices/description": {
					blocks: [
						{
							types: [`${title.type}_${title.style}`],
						},
						{
							types: [`${text.type}_${text.style}`],
						},
						{
							types: [`${text.type}_${text.style}`],
						},
					],
				},
			},
		},
	},
} as StaticPageConfig
